import { initializeIcons as i } from './fabric-icons';
import { initializeIcons as i0 } from './fabric-icons-0';
import { initializeIcons as i1 } from './fabric-icons-1';
import { initializeIcons as i2 } from './fabric-icons-2';
import { initializeIcons as i3 } from './fabric-icons-3';
import { initializeIcons as i4 } from './fabric-icons-4';
import { initializeIcons as i5 } from './fabric-icons-5';
import { initializeIcons as i6 } from './fabric-icons-6';
import { initializeIcons as i7 } from './fabric-icons-7';
import { initializeIcons as i8 } from './fabric-icons-8';
import { initializeIcons as i9 } from './fabric-icons-9';
import { initializeIcons as i10 } from './fabric-icons-10';
import { initializeIcons as i11 } from './fabric-icons-11';
import { initializeIcons as i12 } from './fabric-icons-12';
import { initializeIcons as i13 } from './fabric-icons-13';
import { initializeIcons as i14 } from './fabric-icons-14';
import { initializeIcons as i15 } from './fabric-icons-15';
import { initializeIcons as i16 } from './fabric-icons-16';
import { initializeIcons as i17 } from './fabric-icons-17';
import { registerIconAliases } from './iconAliases';
import { getWindow } from '@uifabric/utilities';
var DEFAULT_BASE_URL = 'https://res.cdn.office.net/files/fabric-cdn-prod_20241209.001/assets/icons/';
var win = getWindow();
export function initializeIcons(baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = ((_b = (_a = win) === null || _a === void 0 ? void 0 : _a.FabricConfig) === null || _b === void 0 ? void 0 : _b.iconBaseUrl) || ((_d = (_c = win) === null || _c === void 0 ? void 0 : _c.FabricConfig) === null || _d === void 0 ? void 0 : _d.fontBaseUrl) || DEFAULT_BASE_URL; }
    var _a, _b, _c, _d;
    [
        i,
        i0,
        i1,
        i2,
        i3,
        i4,
        i5,
        i6,
        i7,
        i8,
        i9,
        i10,
        i11,
        i12,
        i13,
        i14,
        i15,
        i16,
        i17,
    ].forEach(function (initialize) { return initialize(baseUrl, options); });
    registerIconAliases();
}
import './version';
//# sourceMappingURL=index.js.map